import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-text, comment, feedback"} maskId="square-filled-radius-0-stroke-1-IconBubbleText"><path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3.00002V19H15.1957L11.996 21.6509L8.83366 19L3 19V3ZM8 8.5V9.5H16V8.5H8ZM8 12.5V13.5H16V12.5H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleText;
